export const whyUseAddText = [
	{
		icon: '✅',
		title: 'whyUseData.title1',
		subtitle: 'whyUseData.subtitle1',
	},
	{
		icon: '✅',
		title: 'whyUseData.title2',
		subtitle: 'whyUseData.subtitle2',
	},
	{
		icon: '✅',
		title: 'whyUseData.title3',
		subtitle: 'whyUseData.subtitle3',
	},
	{
		icon: '✅',
		title: 'whyUseData.title4',
		subtitle: 'whyUseData.subtitle4',
	},
];
